<template>
  <div class="layout-pricing page-max-width footer-max-width">
    <QHeader class="bg-transparent text-white">
      <QToolbar>
        <QBtn v-if="backRoute || goBack" flat round dense icon="icon-f-arrow-left" @click="onBack" />
        <QToolbarTitle>
          <h2 class="layout-pricing-title">
            {{ $t(title) }}
          </h2>
        </QToolbarTitle>
      </QToolbar>
    </QHeader>

    <router-view />
  </div>
</template>

<script>
  import { RouterHelpers } from "@core/helpers";
  import { StatusBar } from "@core/plugins/mobile";
  import { META_HEADER_TITLE } from "@core/constants";
  import { META_BACK, META_BACK_ROUTE } from "@etab/config";

  export default {
    created() {
      StatusBar.setBlackBackground();

      this.goBack = RouterHelpers.getRouteMeta(this.$route, META_BACK);
      this.backRoute = RouterHelpers.getRouteMeta(this.$route, META_BACK_ROUTE);
      this.title = RouterHelpers.getRouteMeta(this.$route, META_HEADER_TITLE);
    },
    beforeUnmount() {
      StatusBar.setDefault();
    },
    methods: {
      onBack() {
        if (this.backRoute) {
          this.$router.replace(this.backRoute).catch((suppressedError) => {});
        }
        if (this.goBack) {
          this.$router.go(-1);
        }
      },
    },
  };
</script>

<style lang="scss">
  .layout-pricing {
    background: url("~@etab/assets/img/pricing_background.jpg") no-repeat center top fixed;
    background-size: cover;

    .layout-pricing-title {
      font-size: 22px;
      margin: 0;
    }

    .q-page {
      > section,
      article {
        margin: 12px 20px;
        color: $primary-medium;
        padding: 15px;
        border-radius: 2px;
        box-shadow: $soft-shadow;
        background-color: #ffffff;
        text-align: center;

        h3 {
          font-size: 20px;
          font-weight: 800;
          margin: 0 0 10px;
          letter-spacing: 1.3px;
          line-height: 1.2;
        }

        .q-list {
          .q-item {
            padding: 8px;

            .q-item__section--avatar {
              min-width: 0; // quasar fix to limit the size of the avatar section
            }
          }

          .q-separator {
            background-color: transparent;
            background-image: linear-gradient(to right, $primary-lighter 33%, rgba(255, 255, 255, 0) 0%);
            background-position: bottom;
            background-size: 7px 1px;
            background-repeat: repeat-x;
          }
        }
      }
    }

    .q-footer {
      @media screen and (min-width: $breakpoint-sm-max) {
        margin-bottom: 25px;
        padding: 0 25px;
      }
      > div {
        margin-top: 15px;
        text-align: center;
      }
    }
  }
</style>
